export class UserInfo {
    groups: string[];
    permission: boolean;
}